"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeDeleteWorkOrderComment = exports.conciergeUpdateWorkOrderComment = exports.conciergeCreateWorkOrderComment = exports.conciergeGetWorkOrderCommentsByWorkOrderId = void 0;
const client_1 = require("@apollo/client");
const fragments_graphql_1 = require("../fragments.graphql");
exports.conciergeGetWorkOrderCommentsByWorkOrderId = (0, client_1.gql) `
  ${fragments_graphql_1.WORK_ORDER_COMMENT_FIELDS}
  query conciergeGetWorkOrderCommentsByWorkOrderId($workOrderId: ID!) {
    conciergeGetWorkOrderCommentsByWorkOrderId(workOrderId: $workOrderId) {
      ...WorkOrderCommentFields
    }
  }
`;
exports.conciergeCreateWorkOrderComment = (0, client_1.gql) `
  mutation conciergeCreateWorkOrderComment($input: WorkOrderCommentCreateInput!) {
    conciergeCreateWorkOrderComment(input: $input) {
      id
    }
  }
`;
exports.conciergeUpdateWorkOrderComment = (0, client_1.gql) `
  mutation conciergeUpdateWorkOrderComment($id: ID!, $input: WorkOrderCommentUpdateInput!) {
    conciergeUpdateWorkOrderComment(id: $id, input: $input) {
      id
    }
  }
`;
exports.conciergeDeleteWorkOrderComment = (0, client_1.gql) `
  mutation conciergeDeleteWorkOrderComment($id: ID!) {
    conciergeDeleteWorkOrderComment(id: $id) {
      id
    }
  }
`;
//# sourceMappingURL=work-order-comment.queries.graphql.js.map